import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";

import ContentBox from "layout/atoms/ContentBox";
import Loader from "layout/atoms/Loader";
import Modal from "layout/atoms/Modal";
import PersonList from "layout/molecules/PersonList";

import {
  listVoters,
  selectIdeaById,
  selectIdeasStatus,
} from "store/currentBoardSlice";
import { closeModal } from "store/modalsSlice";

const VotersModal = ({ ideaId, boardId }) => {
  const dispatch = useDispatch();
  const { t } = useTranslation("translation", {
    keyPrefix: "boardsDetails.ideaCard",
  });
  const idea = useSelector((state) => selectIdeaById(state, ideaId));
  const { listVoters: votersStatus } = useSelector(selectIdeasStatus);

  useEffect(() => {
    dispatch(listVoters({ ideaId, boardId }));
  }, [dispatch, ideaId, boardId]);

  const handleClose = () => dispatch(closeModal("votersModal"));

  const voters = idea?.voters
    ? [...idea.voters].sort((a, b) => a.name.localeCompare(b.name))
    : null;

  return (
    <Modal open onClose={handleClose}>
      <ContentBox
        header={
          <h3>
            {t("voters", { defaultValue: "Voters" })}
            {voters ? ` (${voters.length})` : ""}
          </h3>
        }
      >
        {votersStatus === "loading" && !voters && <Loader size={40} />}
        {voters && (
          <PersonList
            items={voters.map((voter) => ({
              id: voter.id,
              name: voter.name,
            }))}
          />
        )}
      </ContentBox>
    </Modal>
  );
};

export default VotersModal;
